import ModalCallbackFeedbackFormPresenter from "../components/modal-callback-feedback-form/presenter/modal-callback-feedback-form.js";

const triggers = document.querySelectorAll(`.phone-button, .button_footer, .banners-list__item_button_cta`);

Array.from(triggers)
  .forEach((trigger) => {
    const presenter = new ModalCallbackFeedbackFormPresenter(trigger);
    presenter.init();
  });
